module.exports = __webpack_public_path__ + "static/media/history-01.c0d43320.png";